export const getStudentTableColumns = () => [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      render: (text, record, index) => text || `S${(index + 1).toString().padStart(3, '0')}`,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => {
        if (text) return text;
        if (record.fullName) return record.fullName;
        if (record.firstName || record.lastName) {
          return `${record.firstName || ''} ${record.lastName || ''}`.trim();
        }
        return "N/A";
      },
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
      render: (text) => text || "N/A",
    },
    {
      title: "Class",
      dataIndex: "class",
      key: "class",
      render: (text, record) => {
        if (text) return text;
        if (record.grade) return `Grade ${record.grade}`;
        if (record.className) return record.className;
        return "N/A";
      },
    },
  ];